import { Component, ViewChild } from "@angular/core";
import { TreeEditorNode, TreeEditorComponent } from "../../elements/tree-editor/tree-editor.component";

@Component({
  selector: "test-page",
  templateUrl: "./test-page.component.html",
  styleUrls: ["./test-page.component.css"],
})
export class TestPageComponent {

  @ViewChild('treeEditor1') treeEditor1: TreeEditorComponent;
  @ViewChild('treeEditor2') treeEditor2: TreeEditorComponent;

  firstSelectedData: TreeEditorNode[] = [];
  secondSelectedData: TreeEditorNode[] = [];
  availableData: TreeEditorNode[] = [];

  testData1: TreeEditorNode[] = [];
  testData2: TreeEditorNode[] = [];
  onOne: boolean = true;

  constructor() {
    this.testData1 = [
      {
        parent: undefined,
        children: [],
        item: 'Item A',
        value: 'itema',
        source: {},
        sourceType: 0
      }, {
        parent: undefined,
        children: [],
        item: 'Item B',
        value: 'itemb',
        source: {},
        sourceType: 0
      },{
      parent: undefined,
        children: [],
        item: 'Item C',
        value: 'itemc',
        source: {},
      sourceType: 0
    }
    ];
    var subItemsA: TreeEditorNode[] = [
      {
        parent: this.testData1[0],
        children: [],
        item: 'Item A - 1',
        value: 'itema-1',
        source: {
          value: 'itema-1'
        },
        sourceType: 0
      }, {
        parent: this.testData1[0],
        children: [],
        item: 'Item A - 2',
        value: 'itema-2',
        source: {
          value: 'itema-2'
        },
        sourceType: 0
      }, {
        parent: this.testData1[0],
        children: [],
        item: 'Item A - 3',
        value: 'itema-3',
        source: {
          value: 'itema-3'
        },
        sourceType: 0
      }
    ];
    this.testData1[0].children = subItemsA;
    var subItemsB: TreeEditorNode[] = [
      {
        parent: this.testData1[1],
        children: [],
        item: 'Item B - 1',
        value: 'itemb-1',
        source: {
          value: 'itemb-1'
        },
        sourceType: 0
      }, {
        parent: this.testData1[1],
        children: [],
        item: 'Item B - 2',
        value: 'itemb-2',
        source: {
          value: 'itemb-2'
        },
        sourceType: 0
      }, {
        parent: this.testData1[1],
        children: [],
        item: 'Item B - 3',
        value: 'itemb-3',
        source: {
          value: 'itemb-3'
        },
        sourceType: 0
      }
    ];
    this.testData1[1].children = subItemsB;
    var subItemsC: TreeEditorNode[] = [
      {
        parent: this.testData1[2],
        children: [],
        item: 'Item C - 1',
        value: 'itemc-1',
        source: {
          value: 'itemc-1'
        },
        sourceType: 0
      }, {
        parent: this.testData1[2],
        children: [],
        item: 'Item C - 2',
        value: 'itemc-2',
        source: {
          value: 'itemc-2'
        },
        sourceType: 0
      }, {
        parent: this.testData1[2],
        children: [],
        item: 'Item C - 3',
        value: 'itemc-3',
        source: {
          value: 'itemc-3'
        },
        sourceType: 0
      }
    ];
    this.testData1[2].children = subItemsC;

    this.testData2 = [
      {
        parent: undefined,
        children: [],
        item: 'Item A',
        value: 'itema',
        source: {
          value: 'itema'
        },
        sourceType: 0
      }, {
        parent: undefined,
        children: [],
        item: 'Item B',
        value: 'itemb',
        source: {
          value: 'itemb'
        },
        sourceType: 0
      }, {
        parent: undefined,
        children: [],
        item: 'Item C',
        value: 'itemc',
        source: {
          value: 'itemc'
        },
        sourceType: 0
      }
    ];
    var subItemsA2: TreeEditorNode[] = [
      {
        parent: this.testData2[0],
        children: [],
        item: 'Item A - 1',
        value: 'itema-1',
        source: {
          value: 'itema-1'
        },
        sourceType: 0
      }, {
        parent: this.testData2[0],
        children: [],
        item: 'Item A - 2',
        value: 'itema-2',
        source: {
          value: 'itema-2'
        },
        sourceType: 0
      }, {
        parent: this.testData2[0],
        children: [],
        item: 'Item A - 3',
        value: 'itema-3',
        source: {
          value: 'itema-3'
        },
        sourceType: 0
      }
    ];
    this.testData2[0].children = subItemsA2;
    var subItemsB2: TreeEditorNode[] = [
      {
        parent: this.testData2[1],
        children: [],
        item: 'Item B - 1',
        value: 'itemb-1',
        source: {
          value: 'itemb-1'
        },
        sourceType: 0
      }, {
        parent: this.testData2[1],
        children: [],
        item: 'Item B - 2',
        value: 'itemb-2',
        source: {
          value: 'itemb-2'
        },
        sourceType: 0
      }, {
        parent: this.testData2[1],
        children: [],
        item: 'Item B - 3',
        value: 'itemb-3',
        source: {
          value: 'itemb-3'
        },
        sourceType: 0
      }
    ];
    this.testData2[1].children = subItemsB2;
    
    this.availableData = this.testData1;
    this.firstSelectedData = [];

  }

  copySelection() {
    var selectedValues = this.treeEditor1.getSelectedValues();
    this.treeEditor2.setSelectedValues(selectedValues);
  }

  changeDataSource() {
    if (this.onOne) {
      this.availableData = this.testData2;
      this.onOne = false;
    } else {
      this.availableData = this.testData1;
      this.onOne = true;
    }
  }
}
